import { readable, writable, derived } from 'svelte/store';
import { isBetween } from './utils';
import { FILE_NOTES, FILE_CHAPTERS, TEXT_PLAY, TEXT_LOADING, TEXT_CONTINUE, TEXT_REPLAY } from './config';
import find from 'lodash/find';
import get from 'lodash/get';
import last from 'lodash/last';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import flatten from 'lodash/flatten';

const images = [];
function preload(arr) {
  for (let i = 0; i < arr.length; i++) {
    images[i] = new Image();
    images[i].src = arr[i];
  }
}

export const NOTES = readable([], (set) => {
	fetch(FILE_NOTES)
	  .then(response => response.json())
	  .then(datum => {
	    set(datum)
	    preload(
	    	map(flatten(map(datum, (el) => get(el, 'images', []))), (img) => `./img/${img}`)
			)
	  });
});

export const NOTES_PER_CHAPTER = derived(NOTES, ($NOTES) => {
	return groupBy($NOTES, 'chapter')
});

export const CHAPTERS = readable([], (set) => {
	fetch(FILE_CHAPTERS)
	  .then(response => response.json())
	  .then(datum => {
	    set(datum)
	  });
});

// Is the video currently playing. Is set by the callback of the play function and the pause function
// This is toggled by hovering over the sidebar
export const IS_PLAYING = writable(false)

export const IS_STOPPED = writable(true)

export const IS_LOADING = writable(false)

export const IS_FINISHED = writable(false)

export const IS_LOADED = writable(false)

export const FOOTNOTE_HOVER_ID = writable(false)

export const TIME = writable(0) // in seconds

// The current chapter is find through the current time
export const CURRENT_CHAPTER = derived([TIME, CHAPTERS], ([$TIME, $CHAPTERS]) => {
	const currentChapter = find($CHAPTERS, ({ start, end }) => {
		return isBetween($TIME, start, end)
	})
	// Find the current chapter by checking if the current time is between start and end time of each chapter. Otherwise retrun an empty object
	return find($CHAPTERS, ({ start, end }) => {
		return isBetween($TIME, start, end)
	}) || last($CHAPTERS) || {}
});

// The current notes are derived from the current chapter and the notes
export const CURRENT_CHAPTER_NOTES = derived([CURRENT_CHAPTER, NOTES_PER_CHAPTER], ([{ number }, $NOTES_PER_CHAPTER]) => {
	// console.log(get($NOTES_PER_CHAPTER, number, []))
	return get($NOTES_PER_CHAPTER, number, [])
});

// Every time the user stops the film or the film is finished, the interface is shown
export const IS_INTERFACE_VISIBLE = derived([IS_STOPPED, IS_FINISHED], ([$IS_STOPPED, $IS_FINISHED]) => {
	return $IS_STOPPED || $IS_FINISHED
})

// This is used to check if the film has already started
export const IS_START = derived(TIME, ($TIME) => $TIME === 0)

// The »Play« button text is generated based on the loading or playback status of the film
export const BUTTON_TEXT = derived([IS_LOADING, IS_LOADED, IS_FINISHED, IS_START], ([$IS_LOADING, $IS_LOADED, $IS_FINISHED, $IS_START]) => {
	if ($IS_LOADING) { return TEXT_LOADING }
  if (!$IS_LOADED) { return TEXT_LOADING }
  if ($IS_FINISHED) { return TEXT_REPLAY }
  if (!$IS_START) { return TEXT_CONTINUE }
  return TEXT_PLAY
})
